import React from 'react'

import "./team.css"
import gregWatkinson from "../../../assets/brand/gregwatkinson.jpg"

export default function Team() {
  return (
    <div className='emas__team'>
      <div className='emas__team-head'>
        <h1>Our Team</h1>
        <p>Together we have over 40 years of experience in the WA electricity market. Peter Shardlow is a leading expert in modelling the electricity market and has provided advice to a broad range of market participants and designers. Peter combines data science skills with a deep understanding of the electricity market to provide cutting-edge modelling solutions. Before establishing EMAS with Peter Shardlow, Greg Watkinson was a Governing Body member and CEO of the Economic Regulation Authority and financial modelling consultant.</p>
      </div>
      <div className='emas__team-container'>
        <div className='emas__team-container_peter'>
          <div>
          <h1>Peter Shardlow</h1>
          <h2>Director, Electricity Market Advisory Services</h2>
          </div>
        </div>
        <div className='emas__team-container_greg'>
          <div>
            <h1>Greg Watkinson</h1>
            <h2>Director, Electricity Market Advisory Services</h2>
          </div>
        </div>
      </div>
    </div>
  )
}
